import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";

export interface AlertModel {
  title:string;
  obj:string;
}

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent extends DialogComponent<AlertModel, boolean> implements AlertModel {
  title: string;
  obj: string;
  constructor(dialogService: DialogService) {
    super(dialogService);
  }
  
  confirm() {
    this.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/alert/alert.component.ts